import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AddressPipe } from './address.pipe';
import { CurrencyLocalePipe } from './currency-language';
import { DocumentPipe } from './document.pipe';
import { PercentLocalePipe } from './percent-language';
import { PhonePipe } from './phone.pipe';
import { ZipCodePipe } from './zipcode.pipe';

@NgModule({
  declarations: [ZipCodePipe, AddressPipe, PhonePipe, DocumentPipe, CurrencyLocalePipe, PercentLocalePipe],
  imports: [CommonModule],
  exports: [ZipCodePipe, AddressPipe, PhonePipe, DocumentPipe, CurrencyLocalePipe, PercentLocalePipe]
})
export class PipeModule {}
